import { RoleType } from "../dataTypes/generated"

export const AdminOnly: RoleType[] = ["ADMIN"]
export const ContentCreators: RoleType[] = ["CONTENT_MANAGER", "IMPULSE_PARTNER", "SUPPORT_PARTNER", "CO_MANAGER_PROJECT", "CO_MANAGER_DRIVERS"]

